import { faFile } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

/**
 * Signals that the file-upload controls are being rendered for print (e.g. the TM3 print page).
 * Consumers branch on this to render PrintedFileList (filenames straight from reportData) instead
 * of SubmittedFileList (interactive fetch + download icon). Defaults to false, so any call site
 * not under a Provider keeps its existing SubmittedFileList behaviour.
 */
export const FormFilePrintModeContext = React.createContext<boolean>(false);

interface Props {
  names: string[];
}

const PrintedFileList: React.FC<Props> = ({ names }) => {
  if (!names || names.length === 0) {
    return <span className="text-sm text-neutral-400">No files uploaded</span>;
  }

  return (
    <div className="mt-1 flex flex-col gap-1" data-testid="printed-file-list">
      {names.map((name, i) => (
        <div
          key={`${name}-${i}`}
          className="flex items-center gap-2 px-2 py-1.5 rounded border border-neutral-200 text-sm"
        >
          <FontAwesomeIcon icon={faFile} fixedWidth />
          <span className="flex-1 truncate">{name}</span>
        </div>
      ))}
    </div>
  );
};

export default PrintedFileList;
